import React from "react";

const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL;

function Checkbox({ size, checked, onChange }) {
  return (
    <>
      {checked ? (
        <img
          alt="check"
          onClick={onChange}
          src={`${S3_BASE_URL}/assets/icons/check_a.svg`}
          style={{
            height: size ? size : 15,
            width: size ? size : 15,
            marginTop: 1,
          }}
        />
      ) : (
        <img
          alt="check"
          onClick={onChange}
          src={`${S3_BASE_URL}/assets/icons/check_d.png`}
          style={{
            height: size ? size : 15,
            width: size ? size : 15,
            marginTop: 1,
          }}
        />
      )}
    </>
  );
}

export default Checkbox;
